import { render, staticRenderFns } from "./MenuButtom.vue?vue&type=template&id=3e46a390&scoped=true&"
import script from "./MenuButtom.vue?vue&type=script&lang=js&"
export * from "./MenuButtom.vue?vue&type=script&lang=js&"
import style0 from "./MenuButtom.vue?vue&type=style&index=0&id=3e46a390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e46a390",
  null
  
)

export default component.exports